import { useCallback, useEffect, useRef, useState } from 'react';
import './MobileSidebar.scss';
import Drawer from '@mui/material/Drawer';
import { useAppSelector } from '../../redux/app/hooks';
import { useDispatch } from 'react-redux';
import { logout, setIsSidebarOpen, setSplashvisible, setSelectedTabindex, setRefetchNotification } from '../../redux/slices/authSlice';
import images from '../../assets/images';
import Tooltip from '@mui/material/Tooltip';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, PATH_ADDRESSES, PTA_ROLE, SCHOOL_ADMIN, STUDENT_ROLE, TEACHER_ROLE } from '../../utils/constants';
import { getScreenDimensions } from '../../utils/helper';
import { useLazyQuery } from '@apollo/client';
import { GET_CHAT_INDICATION, GET_CLASSROOM_UPDATES, GET_NOTIFICATIONS } from '../../pages/TeacherStudentClassroom/api/TeacherStudentClassroomQuery';
import { GET_ALL_MEETING_CATEGORIES } from '../../pages/AdminPta/api/PtaQuery';
import { MeetingCategoryType } from '../../pages/AdminPta/AdminPta';
import ToasterWithMessage from '../toaster';
import { setCategoryListLoading } from '../../redux/slices/dashboardSlice';
import { GetChatCountResponse, GetClassroomUpdatesResponse, GetClassroomUpdatesVariables } from '../../pages/TeacherStudentClassroom/types/TeacherStudentClassroom';
import { setChatTabIndication, setTabIndication } from '../../redux/slices/indication';

interface NotificationType{
    Announcement:number;
    Calender:number;
    Workshop:number
}

const drawerStyle = {
    '& .MuiPaper-root': {
        width: getScreenDimensions()?.width > 375 ? '300px' : '250px',
        height: '100%',
        padding: '0px'
    }
};

const MobileSidebar = () => {

    const { logoutGif, logoutIconMobile, classroomActiveIcon, classroomInactiveIcon, announcementActiveIcon, 
    announcementInactiveIcon, settings_active, settings_inactive, MobileNotificationActive, MobileNotificationInactive,
    MobileDashboardActive, MobileDashboardInactive, MobileWorkshopActive, MobileWorkshopInactive,
    MobileSystemMessageActive, MobileSystemMessageInactive, MobileHelp, workshopParticipantActive, workshopParticipantInactive, 
    AnnouncementIconActive, AnnouncementIconInActive, mobileGeneralMeetingInActive, mobileGeneralMeetingActive, 
    ptaOtherMeetingActive, ptaOtherMeetingInactive,ActiveCalendarIcon,InActiveCalendarIcon, UploadIconDashboard } = images;
    const { adminProfileImage: profileImage, isSidebarOpen, role, adminProfile: profile } = useAppSelector((state) => state?.auth);
    const dispatch = useDispatch();
    const schoolNameRef = useRef<HTMLDivElement | null>(null);
    const [isOverflow, setIsOverflow] = useState(false);
    const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();
    const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
    const classRoomName = useAppSelector((state) => state.auth.selectedClassRoomName);
    const tab = role === SCHOOL_ADMIN ? localStorage?.getItem('adminDashboardTabIndex') : localStorage?.getItem('teacherStudentTabIndex');
    const [activeTab, setActiveTab] = useState(tab ? parseInt(tab) : null);
    const isMylibaryActive = useAppSelector((state) => state.indication.indication.myLibary)
    const isLiveActive = useAppSelector((state) => state.indication.indication.live)
    const [notification, setNotification] = useState<NotificationType>();
    const refetchNotification = useAppSelector((state) => state?.auth?.refetchNotification);
    const textRef = useRef<HTMLDivElement>(null);
    const [isEllipsisActive, setIsEllipsisActive] = useState(false);
    const selectedCategory: MeetingCategoryType = location?.state?.category;
    const { error } = ToasterWithMessage();
    const [allCategory, setAllCategory] = useState<MeetingCategoryType[]>([]);
    const [oneMenuItems, setOneMenuItems] = useState<any>([]);
    const isquizActive = useAppSelector((state) => state.indication.indication.quiz)
    const isAssignmentActive = useAppSelector((state) => state.indication.indication.assignment)
    const [showPtaSideBar, setShowPtaSideBar] = useState<boolean>(false);
    const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
    const schoolType = useAppSelector((state) => state.auth.schoolType);
    const isChime = process.env.REACT_APP_COMMON_CHAT_SERVICE === 'CHIME';

    const [getAllMeetingCategory, { loading: categoryLoading }] = useLazyQuery(GET_ALL_MEETING_CATEGORIES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
            const ptaMenuItems: any = []
            setAllCategory(data?.allMeetingCategories?.nodes);
            data?.allMeetingCategories?.nodes?.map((val: MeetingCategoryType, index: number) => {
                if (index === 0 && (role === PTA_ROLE || role === TEACHER_ROLE)) {
                    localStorage.setItem("generalCode", val?.mcCode);
                }
                ptaMenuItems.push({
                    id: val?.mcCode,
                    label: val?.mcOriginalType,
                    link: PATH_ADDRESSES?.PTA_MEETINGS_PATH,
                    inactiveIcon: (index === 0 ? mobileGeneralMeetingInActive : ptaOtherMeetingActive),
                    activeIcon: (index === 0 ? mobileGeneralMeetingActive : ptaOtherMeetingActive),
                    set: "setOne",
                    category: val
                });
            })
            if (role === PTA_ROLE && selectedCategory === undefined) {
                localStorage.setItem('isVerify','false');
                navigate(ptaMenuItems?.[0]?.link, {
                    state: {
                        category: data?.allMeetingCategories?.nodes?.[0]
                    }
                });
            }
            setOneMenuItems(ptaMenuItems);
        },
        onError: (err) => {
            error(err?.message);
        }
    });

    useEffect(() => {
        dispatch(setCategoryListLoading({ categoryListLoading: categoryLoading }))
    },[categoryLoading])

    const [getClassRoomUpdates] = useLazyQuery<
        GetClassroomUpdatesResponse,
        GetClassroomUpdatesVariables
      >(GET_CLASSROOM_UPDATES, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
          const { quiz, assignments, mylibrary, ebooks } = data.getClassroomUpdates;
          const quizCount = quiz.totalCount;
          const hasQuiz = quizCount > 0;
          const assignmentCount = assignments.totalCount;
          const hasAssignment = assignmentCount > 0;
          const myLibrayCount = mylibrary.totalCount;
          const ebooksCount = ebooks.totalCount;
          const hasMylibrary = myLibrayCount > 0;
          const hasEbooks = ebooksCount > 0;
    
          // Set tab indication based on either quiz or assignment presence
          dispatch(
            setTabIndication(hasQuiz || hasAssignment || hasMylibrary || hasEbooks)
          );
        },
        onError: (err) => {
          console.log(err.message);
        },
      });
    
      //indication for chat
      const [getIndicationChat] = useLazyQuery<
        GetChatCountResponse,
        GetClassroomUpdatesVariables
      >(GET_CHAT_INDICATION, {
        fetchPolicy: FETCH_POLICY,
        onCompleted: (data) => {
          const chatCount = data.getAllChatCount;
          const hasChat = chatCount > 0;
          dispatch(setChatTabIndication(hasChat));
        },
        onError: (err) => {
          console.log(err.message);
        },
      });

    const schoolAdminMenus = [
        { id: 'Dashboard', label: "Dashboard", inactiveIcon: MobileDashboardInactive, activeIcon: MobileDashboardActive, link: PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH , set: "setOne"},
        { id: 'Upload', label: "Upload", inactiveIcon: UploadIconDashboard, activeIcon: UploadIconDashboard , link: "/admin-materials-upload", set: "setOne" },
        { id: 'Workshop', label: "Workshop", inactiveIcon: MobileWorkshopInactive, activeIcon: MobileWorkshopActive, link: "/admin-workshop" , set: "setOne"},
        { id: 'Notification', label: "Notification", inactiveIcon: MobileNotificationInactive, activeIcon: MobileNotificationActive, link: "/admin-notification" , set: "setOne"},
        { id: 'SystemMessages', label: "System Messages", inactiveIcon: MobileSystemMessageInactive, activeIcon: MobileSystemMessageActive, link: "/admin-system-message" , set: "setOne"},
    ];

    const teacherStudentMenus = [
        { id: 'Classroom', label: "Classroom", inactiveIcon: classroomInactiveIcon, activeIcon: classroomActiveIcon, link: role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH , set: "setOne", hasSubmenu: true, submenus : [
            { id: 'MyLibrary', label: "My Library" , index: 0},
            { id: 'Quiz', label: "Quiz" , index: 1},
            { id: 'Assignment', label: "Assignment" , index: 2},
            { id: 'Chats', label: "Chats" , index: 3},
            { id: 'LiveClass', label: "Live Class" , index: 4}
        ]},
        ...(role === TEACHER_ROLE ? [{ id: 'Workshop', label: "Workshop", inactiveIcon: workshopParticipantInactive, activeIcon: workshopParticipantActive, link: "/teacher-workshop" , set: "setOne"}]:[]),
        { id: 'Calendar', label: "Calendar", inactiveIcon: InActiveCalendarIcon, activeIcon: ActiveCalendarIcon, link: role === STUDENT_ROLE ? "/student-calendar" : "/teacher-calendar" , set: "setOne"},
        { id: 'Announcement', label: "Announcement", inactiveIcon: AnnouncementIconInActive, activeIcon: AnnouncementIconActive, link: role === STUDENT_ROLE ? "/student-announcement" : "/teacher-announcement" , set: "setOne"},
        ...((role === TEACHER_ROLE && allCategory?.length > 0) ? [{ id: 'PTAMeetings', label: "PTA Meetings", inactiveIcon: mobileGeneralMeetingInActive, activeIcon: mobileGeneralMeetingActive, link: PATH_ADDRESSES?.TEACHER_PTA_PATH , set: "setOne", hasSubmenu: true, submenus : allCategory?.map((value, index) => ({ id: value?.mcCode, label: value?.mcOriginalType, index, link: PATH_ADDRESSES?.TEACHER_PTA_PATH, category: value }))}]:[]),
    ];

    const menuItems = [
        ...(role === SCHOOL_ADMIN ? schoolAdminMenus : role === PTA_ROLE ? oneMenuItems : teacherStudentMenus),
        ...((role !== PTA_ROLE) ? [{ id: 'Settings', label: "Settings", inactiveIcon: settings_inactive, activeIcon: settings_active, link: (role === SCHOOL_ADMIN ? "/admin-settings" : role === TEACHER_ROLE ? "/teacher-settings" : "/student-settings"), set: "setTwo" },
        { id: 'Help', label: "Help", inactiveIcon: MobileHelp, activeIcon: MobileHelp, link: (role === SCHOOL_ADMIN ? "/admin-help" : role === TEACHER_ROLE ? "/teacher-help" : "/student-help"), set: "setTwo" }] : []),
        { id: 'Logout', label: "Logout", inactiveIcon: logoutIconMobile, activeIcon: logoutIconMobile, link: "/", set: "setThree" },
    ];

    const toggleSidebar = (newOpen: boolean) => () => {
        dispatch(setIsSidebarOpen({ isSidebarOpen: newOpen }));
    };

    const checkOverflow = () => {
        if (schoolNameRef.current) {
          setIsOverflow(schoolNameRef.current.scrollWidth > schoolNameRef.current.clientWidth);
        }
    };

    const onYesButtonClick = () => {
        dispatch(logout());
        dispatch(setSplashvisible());
        setOpenConfirmationPopup(false);
    };

    const onNoButtonClick = () => {
        setOpenConfirmationPopup(false);
    };

    const onLogoutClick = () => {
        setOpenConfirmationPopup(true);
    };

    const getMenuItemsBySet = (set: string) => {
        return menuItems.filter(item => item.set === set);
    };

    const [getNotifications] = useLazyQuery(GET_NOTIFICATIONS, {
        fetchPolicy: FETCH_POLICY_NO_CACHE,
        onCompleted: (data) => {
            setNotification(data?.notifyUser);
        },
    });

    useEffect(() => {
        if (role !== PTA_ROLE) {
            getNotifications();
        }
        if (role && [TEACHER_ROLE, PTA_ROLE]?.includes(role)) {
            getAllMeetingCategory();
        }
    }, []);

    useEffect(() => {
        if (role !== PTA_ROLE && refetchNotification) {
            getNotifications();
            dispatch(setRefetchNotification({ refetchNotification: false }));
        }
    }, [refetchNotification]);

    const onMenuClick = async (menu: any) => {
        if (role !== PTA_ROLE) {
            await getNotifications();
        }
        if (activeTab === null && menu?.link === PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH) {
            setActiveTab(0);
        }
        if (menu?.link === PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH) {
            setActiveTab(null);
        }
        dispatch(setIsSidebarOpen({ isSidebarOpen: false }));
        if (menu?.link === PATH_ADDRESSES?.TEACHER_PTA_PATH || menu?.link === PATH_ADDRESSES?.PTA_MEETINGS_PATH) {
            if (role === PTA_ROLE) {
                localStorage.setItem('isVerify','false');
            }
            navigate(menu?.link, {
                state: {
                    category: role === PTA_ROLE ? menu?.category : menu?.submenus?.[0]?.category
                }
            });
        }
        else {
            navigate(menu?.link);
        }
    };

    const handleSubmenuClick = (submenu:any) => {
        dispatch(setIsSidebarOpen({ isSidebarOpen: false }));
        if (submenu?.link && submenu?.category) {
            navigate(submenu?.link, {
                state: { category: submenu?.category }
            });
            if (role === TEACHER_ROLE) {
                localStorage.setItem('isVerify','false');
            }
        }
        else {
            setActiveTab(submenu?.index);
            localStorage.setItem(role === SCHOOL_ADMIN ? 'adminDashboardTabIndex' :'teacherStudentTabIndex', String(submenu?.index));
            dispatch(setSelectedTabindex({selectedTabindex: String(submenu?.index)}));
            navigate(role === SCHOOL_ADMIN ? PATH_ADDRESSES?.ADMIN_DASHBOARD_PATH : role === STUDENT_ROLE ? PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH : PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
        }
    }    

    const checkEllipsis = useCallback(() => {
        if (textRef.current) {
        setIsEllipsisActive(textRef.current.scrollWidth > textRef.current.clientWidth);
        }
    }, []);

    useEffect(() => {
        checkEllipsis();
        window.addEventListener("resize", checkEllipsis);
        return () => window.removeEventListener("resize", checkEllipsis);
    }, [checkEllipsis, StudentName]);

    const handleClickSchoolProfile = () => {
        if (location.pathname === PATH_ADDRESSES?.TEACHER_PTA_PATH || location.pathname === PATH_ADDRESSES?.PTA_MEETINGS_PATH) {
          setShowPtaSideBar(true);
        }
        if (role !== PTA_ROLE) {
          getNotifications();
        }
        if(role === STUDENT_ROLE){
            getClassRoomUpdates({
              variables :{
                cId : selectedClassRoomId ?? ''
              }
            })
            // if(schoolType !== VIRTUAL){
            getIndicationChat({
              variables: {
                cId: selectedClassRoomId ?? "",
                messagingProvider: isChime ? 'CHIME' : 'WEBSOCKET'
              },
            });
        //   }
          }
        dispatch(setIsSidebarOpen({ isSidebarOpen: false }))
        if (location.pathname !== "/school-profile") {
          navigate("/school-profile", {
            state: {
              backNavigation: location.pathname,
              category: selectedCategory
            }
          });
        }
      };

    return (
        <Drawer open={isSidebarOpen} onClose={toggleSidebar(false)} sx={drawerStyle}>
            <div className='sidebarContainer'>
                <div className='sidebarTopContainer'>
                    <div className='profileContainer' onClick={handleClickSchoolProfile}>
                        <div className='profileImageContainer'>
                            {profileImage && <img src={profileImage} className='profile' alt='profile' />}
                        </div>
                        <div className='nameContainer'>
                            <Tooltip
                                title={`${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                                disableHoverListener={!isOverflow}
                                placement="top"
                            >
                                <div className="name" ref={schoolNameRef} onMouseEnter={checkOverflow}>
                                    {`${profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName ? profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saName : "Katon Virtual School"}`}
                                </div>
                            </Tooltip>
                            {
                                role === STUDENT_ROLE
                                ?
                                <div className='role'>
                                    <Tooltip title={isEllipsisActive ? StudentName || "Student" : ""} arrow>
                                        <div
                                            ref={textRef}
                                            className="namefield">
                                            {StudentName || "Student"}
                                        </div>
                                    </Tooltip>
                                    <div>{(profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName && profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName !== "") && <span>{profile?.getCurrentUser?.nodes?.[0]?.studentsByUId?.nodes?.[0]?.studentClassroomsBySId?.nodes?.[0]?.classroomByCId?.cOriginalName}</span>}</div>
                                </div>
                                : role === TEACHER_ROLE ?
                                <div className='role'>
                                    <div className='namefield'>{`${StudentName ? StudentName : 'Teacher'}`}</div>
                                    <div>
                                        {(classRoomName && classRoomName !== "") && <span>{classRoomName}</span>}
                                    </div>
                                </div>
                                : <div className='role'>{role}</div>
                            }
                        </div>
                    </div>
                    {role === SCHOOL_ADMIN &&
                    <div className={"adminSidebarCards"}>
                              <Link to={"/admin-school"} onClick={() => dispatch(setIsSidebarOpen({ isSidebarOpen: false }))} className={`adminSidebarSchoolCard ${location.pathname === "/admin-school" ? "adminSidebarSelectedCard" : ""}`}>
                                <label htmlFor="customize-school" className="adminSidebarSchoolLabel">Customize</label>
                                <span className="adminSidebarSchoolText">School</span>
                              </Link>
                              <Link to={"/admin-calendar"} onClick={() => dispatch(setIsSidebarOpen({ isSidebarOpen: false }))} className={`adminSidebarCalendarCard ${location.pathname === "/admin-calendar" ? "adminSidebarSelectedCard" : ""}`}>
                                <label htmlFor="edit-calendar" className="adminSidebarCalendarLabel">Edit</label>
                                <span className="adminSidebarCalendarText">Calendar</span>
                              </Link>
                    </div>}
                    <div className='menuItems'>
                        {getMenuItemsBySet("setOne").map((item: any, index: number) => {
                            const activeMenu = ((role === PTA_ROLE && location.pathname === PATH_ADDRESSES?.PTA_MEETINGS_PATH)) ? (item?.id === selectedCategory?.mcCode) : location.pathname.includes(item.link);
                            return (
                                <div className='menuParentContainer' key={item.id}>
                                    <div onClick={() => onMenuClick(item)} className={`menu ${activeMenu ? "menuActive" : ""}`} key={item.id}>
                                        <div className='menuIconContainer'>
                                            <img className={`menuIcon ${(role === PTA_ROLE && index > 0)? "ptaMenuIcon" : ""} `} alt="sidebarIcons" src={activeMenu ? item?.activeIcon : item.inactiveIcon}/>
                                        </div>
                                        <div className={`menuLabel ${activeMenu ? "menuActive" : ""}`}><span>{item.label}</span></div>
                                        {item.id === "Announcement" && (notification?.Announcement ?? 0) > 0 && (
                                            <span className='notificationBadge'>{notification!.Announcement}</span>
                                        )}
                                    </div>
                                    {item.hasSubmenu && (
                                        <div className="submenu-ctn">
                                            {item.submenus && item.submenus.map((submenu: any) => {
                                                const isActiveTab = (location.pathname === PATH_ADDRESSES?.TEACHER_PTA_PATH && item?.id === "PTAMeetings" && submenu?.id === selectedCategory?.mcCode) || (location.pathname === PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH && item?.id === "Classroom" && activeTab === submenu.index);
                                                return (
                                                    <div key={submenu.id} onClick={()=>handleSubmenuClick(submenu)} 
                                                    className={`submenuItem ${isActiveTab ? 'submenuactiveTab' : ''}`}
                                                    >
                                                        {submenu.label}
                                                        <span 
                                                        className="redDot" 
                                                        style={{ 
                                                            visibility:  submenu.index === 0 && isMylibaryActive ? 'visible' : 
                                                            submenu.index === 1 && isquizActive ? 'visible' : 
                                                            submenu.index === 2 && isAssignmentActive ? 'visible' :
                                                            submenu.index === 4 && isLiveActive ? 'visible' :
                                                            'hidden'
                                                        }}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div  className='sidebarBottomContainer'>
                    <div className='menuItems'>
                        {getMenuItemsBySet("setTwo").map((item) => {
                            const activeMenu = location.pathname.includes(item.link);
                            return (
                                <div className='menuParentContainer'>
                                    <div onClick={() => onMenuClick(item)} className={`menu`} key={item.id}>
                                        <div className='menuIconContainer'>
                                            <img className="menuIcon" alt="sidebarIcons" src={activeMenu ? item?.activeIcon : item.inactiveIcon}/>
                                        </div>
                                        <div className={`menuLabel ${activeMenu ? "menusetTwoActive" : ""}` }><span>{item.label}</span></div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className='logoutContainer'>
                        {getMenuItemsBySet("setThree").map((item) => (
                            <div onClick={onLogoutClick} className='menu' key={item.id}>
                                <img className="menuIcon" alt="sidebarIcons" src={item.inactiveIcon}/>
                                <div className="menuLabel"><span>{item.label}</span></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <ConfirmationPopup
                open={openConfirmationPopup}
                message={`Are you sure you want to logout?`}
                gifData={logoutGif}
                yesButtonFunctionality={onYesButtonClick}
                noButtonFunctionality={onNoButtonClick}
                messageWidth={'166px'}
                page='logout'
            />
        </Drawer>
    )
}

export default MobileSidebar;
